<script setup lang="ts">
import { useConfirm, VIcons } from '@/shared/ui'
import { useModel } from './../model/model'
import { useTranslate } from '@/shared/lib'

const { paste } = useModel()
const { show } = useConfirm()
const { trs } = useTranslate()

/**
 * Функция обработчик переноса объекта
 */
const moveHandler = () => {
  show({
    confirmFunc: paste,
    title: trs('itf.move_title'),
  })
}
</script>

<template>
  <div @click="moveHandler"><VIcons type="content_paste" /> {{ $t('itf.paste') }}</div>
</template>
